import React from 'react';
import { Snackbar } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';

const Alert = props => {
	return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const CustomSnackbar = ({ open, message, severity, onClose }) => (
	<Snackbar open={open} autoHideDuration={6000} onClose={onClose}>
		<Alert severity={severity} onClose={onClose}>
			{message}
		</Alert>
	</Snackbar>
);

export default CustomSnackbar;
